import React from 'react';

/**
 * Layout — 공통 페이지 래퍼 (Home, Join 등에서 사용)
 * 다크 그라디언트 배경 + 글로우 효과 + 가운데 정렬
 */
export default function Layout({ children, maxWidth = '400px' }) {
  return (
    <div className="layout-page">
      <div className="layout-glow-orange" aria-hidden="true" />
      <div className="layout-glow-purple" aria-hidden="true" />
      <div className="layout-scroll">
        <div className="layout-inner" style={{ maxWidth }}>
          {children}
        </div>
      </div>
    </div>
  );
}
